import OffcanvasVisualizarDadoHeader from "../OffcanvasVisualizarDados/OffcanvasVisualizarDadoHeader";
import OffcanvasVisualizarDadoBody from "../OffcanvasVisualizarDados/OffcanvasVisualizarDadoBody";
import OffcanvasVisualizarDadoRoot from "../OffcanvasVisualizarDados/OffcanvasVisualizarDadoRoot";

export const OffcanvasVisualizarDado = {
    Root: OffcanvasVisualizarDadoRoot,
    Header: OffcanvasVisualizarDadoHeader,
    Body: OffcanvasVisualizarDadoBody,
};
